"use client";

import FilterToggle from "../atoms/FilterToggle";

interface PropertyTypeFilterProps {
  onFilterChange?: (filters: Record<string, boolean>) => void;
}

export default function PropertyTypeFilter({ onFilterChange }: PropertyTypeFilterProps) {
  const handleFilterClick = (filterType: string) => {
    console.log(`Filter clicked: ${filterType}`);
    onFilterChange?.({ [filterType]: true });
  };

  return (
    <div className="mb-8 flex flex-wrap gap-4 p-4 bg-white rounded-lg shadow">
      <FilterToggle 
        label="Price Range" 
        icon 
        onClick={() => handleFilterClick('priceRange')}
      />
      <FilterToggle 
        label="Property Type" 
        onClick={() => handleFilterClick('propertyType')}
      />
      <FilterToggle 
        label="Bedrooms" 
        onClick={() => handleFilterClick('bedrooms')}
      />
      <FilterToggle 
        label="Sort By" 
        onClick={() => handleFilterClick('sortBy')}
      />
    </div>
  );
} 